// app/javascript/compcalc/components/TempDisability.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';

import EditIcon from '@material-ui/icons/Edit';
import MenuIcon from '@material-ui/icons/Menu';

import DateFnsUtils from '@date-io/date-fns';
import { MuiPickersUtilsProvider, KeyboardDatePicker as DatePicker } from '@material-ui/pickers';

import moment from "moment";

import withErrorHandling from './ErrorHandling';
import TempDisabilityEarningsDialog from './dialogs/TempDisabilityEarningsDialog';
import { currencyFormatter, formatShortDate, isValidDate, saveAsFile, sendMail } from '../utils';
import { getTDForPrint } from '../td_utils';


const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  textField: {
    width: 100,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  // textFieldLarge: {
  //   width: 150,
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  // },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',        // Vertical align.
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  wrapContent: {
    padding: theme.spacing(1),
    display: 'inline-block',
  },
  withSpacing: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class TempDisability extends React.PureComponent {

  constructor() {
    super();

    this.minDate = new Date(1996, 0, 1);
    this.maxDate = new Date(2024, 11, 31);

    this.itemsPercentages = [];
    for (let i = 0; i < 100; ++i) {
      this.itemsPercentages.push(
        <MenuItem dense key={'percent' + i} value={i}>{i}%</MenuItem>
      );
    }

    this.date_4_19_2004 = new Date(2004, 3, 19);

    this.pdRateMaxText = 'TD Rate (maximum)';
    this.pdRateMinText = 'TD Rate (minimum)';
    this.pdRateText = 'TD Rate';

    let startDate = new Date(2015, 0, 1);

    this.initialState = {
      doi: startDate,
      saww: 0,
      increase: 'NA',
      minAWW: 0,
      maxAWW: 0,
      minRate: 0,
      maxRate: 0,

      startDate: startDate,
      endDate: startDate,

      inputAww: false,
      pdRateText: this.pdRateMaxText,
      aww: currencyFormatter.format(0),
      pdRate: currencyFormatter.format(0),

      isManualAww: false,
      awwArray: [],
      awwDialogArray: [],
      isDialogOpen: false,

      weeks: 0,
      days: 0,
      totalDays: 0,
      amount: 0,

      warning: '',
    };
    this.state = { ...this.initialState };
  }

  componentDidMount = () => {
    // console.log('TempDisability.componentDidMount()')
    this.props.setChildMenuHandler(this.handleMenu);
    this.fetchTD();
  }

  fetchTD = () => {
    if (!isValidDate(this.state.doi)) { return; }
    let date = formatShortDate(this.state.doi);
    let url = `api/v1/temporary_disability.json?date=${date}`;

    this.props.fetch(url, results => {
      this.calculate(results);
    }).catch(e => this.props.showError(e, 'Error obtaining temporary disability values from server'));
  }

  // ----------------------- Calculations -----------------------
  dateDiff = (start, end) => {
    let totalDays = end.diff(start, 'days');

    let weeks = totalDays / 7;
    let days = totalDays % 7;

    return {
      weeks: weeks,
      days: days,
      totalDays: totalDays,
    };
  }

  calculate = (results) => {
    this.setState({
      saww: results['saww'],
      increase: results['increase'],
      minAWW: results['minAWW'],
      maxAWW: results['maxAWW'],
      minRate: results['minTDRate'],
      maxRate: results['maxTDRate'],
    }, this.calculateTD);
  }

  calculateTD = () => {
    let doi = this.state.doi;
    let startDate = this.state.startDate;
    let endDate = this.state.endDate;

    if (!isValidDate(doi) || !isValidDate(startDate) || !isValidDate(endDate)) { return; }

    if (startDate < doi)
      startDate = doi;
    if (endDate < startDate)
      endDate = startDate;

    let aww = this.state.inputAww || this.state.isManualAww ? currencyFormatter.parse(this.state.aww) : this.state.maxAWW;
    if (aww == NaN || aww < 0.0)
      aww = 0.0;

    let newState = this.dateDiff(moment(startDate), moment(endDate)); // Returns { weeks, days, totalDays }.

    let pdRate = aww * 2.0/3.0;
    if (pdRate <= 0.0 || pdRate >= this.state.maxRate) {
      newState['pdRateText'] = this.pdRateMaxText;
      pdRate = this.state.maxRate;
    }
    else if (pdRate <= this.state.minRate) {
      newState['pdRateText'] = this.pdRateMinText;
      pdRate = this.state.minRate;
    }
    else {
      newState['pdRateText'] = this.pdRateText;
    }

    let weeks = newState['weeks'];
    let amount = weeks * pdRate;

    let hasWarning = this.date_4_19_2004 <= doi && weeks >= 104.0;
    let warning = hasWarning ? 'Warning: date period calculated is greater than 104 weeks' : '';

    newState = {
      ...newState,
      weeks: Math.floor(weeks),
      aww: currencyFormatter.format(aww),
      pdRate: currencyFormatter.format(pdRate),
      startDate: startDate,
      endDate: endDate,
      warning: warning,
      amount: amount
    }
    this.setState(newState, this.handleMenuCopy);
  }

  // ----------------------- Events -----------------------
  onDialogOpen = () => {
    this.setState({
      awwDialogArray: [ ...this.state.awwArray ],
      isDialogOpen: true,
    });
  };

  onDialogChange = (value) => {
    this.setState({
      awwDialogArray: value
    });
  }

  onDialogClose = (save) => {
    let newState = { isDialogOpen: false };
    if (save) {
      let awwArray = [ ...this.state.awwDialogArray ];

      let days = 0.0, sum = 0.0;
      awwArray.forEach(row => {
        delete row.isSelected;
        let start = moment(row.startDate);
        let end = moment(row.endDate);
        days += end.diff(start, 'days') + 1; // Include end date.
        let wage = currencyFormatter.parse(row.wage);
        sum += wage;
      });

      let aww = sum / days * 7.0;
      let pdRate = aww * 2.0/3.0;

      // console.log('Manual AWW:', days, sum, aww);

      newState = {
        ...newState,
        inputAww: false,
        isManualAww: (save == 1) && (awwArray.length > 0),
        awwArray: awwArray,
        aww: currencyFormatter.format(aww),
        pdRate: currencyFormatter.format(pdRate)
      };
    }
    this.setState(newState, this.calculateTD);
  };

  onDateOfInjuryChange = (date) => {
    if (!isValidDate(date)) { return; }

    this.setState({
      doi: date,
    }, this.fetchTD);
  };

  onStartDateChanged = (date) => {
    if (!isValidDate(date)) { return; }

    // console.log(`onStartDateChanged: ${date} ${this.state.doi}`);
    this.setState({
      startDate: date,
    }, this.calculateTD);
  }

  onEndDateChanged = (date) => {
    if (!isValidDate(date)) { return; }

    // console.log(`onEndDateChanged: ${this.state.dob} ${date}`);
    this.setState({
      endDate: date
    }, this.calculateTD);
  }

  onInputAwwChanged = (checked) => {
    if (this.state.inputAww == checked || this.state.isManualAww) { return; }
    this.setState({
      inputAww: checked
    }, this.calculateTD);
  }

  onAwwChanged = (value) => {
    if (!this.state.inputAww) return;
    let aww = currencyFormatter.parse(value);
    let pdRate = aww * 2.0/3.0;
    // console.log(`onAwwChanged(): ${aww}`);
    this.setState({
      aww: currencyFormatter.format(aww),
      pdRate: currencyFormatter.format(pdRate),
    }, this.calculateTD);
  }

  onPdRateChanged = (value) => {
    if (!this.state.inputAww) return;
    let pdRate = currencyFormatter.parse(value);
    // console.log(`onPdRateChanged(): ${pdRate}`);

    let aww = pdRate * 3.0/2.0;
    this.setState({
      aww: currencyFormatter.format(aww),
      pdRate: currencyFormatter.format(pdRate),
    }, this.calculateTD);
  }

  // --------------------- Menu functions ---------------------
  handleMenu = (menu, submenu, parameter) => {
    // console.log(`handleMenu: menu = ${menu}, submenu = ${submenu}, parameter = ${parameter}`);
    switch (submenu) {
      case 'save':
        this.handleMenuSave();
        break;
      case 'load':
        this.handleMenuLoad();
        break;
      case 'mail':
        this.handleMenuMail();
        break;
      case 'clear':
        this.handleMenuClear();
        break;
      case 'copy':
        // this.handleMenuCopy();
        break;
    }
  }

  handleMenuSave = () => {
    let json = {
      doi: this.state.doi,

      startDate: this.state.startDate,
      endDate: this.state.endDate,

      inputAww: this.state.inputAww,
      aww: this.state.aww,

      isManualAww: this.state.isManualAww,
      awwArray: this.state.awwArray,
    };
    let body = JSON.stringify(json, null, 4);
    saveAsFile('temp-disability.json', body);
  }

  handleMenuLoad = () => {
    this.refs.fileUploader.click();
  }

  onUploadFile = (e) => {
    e.stopPropagation();
    e.preventDefault();
    let file = e.target.files[0];

    let reader = new FileReader();
    reader.addEventListener('load', (e) => {
      // console.log(e.target.result);
      try {
        let hash = JSON.parse(e.target.result);
        let awwArray = hash.awwArray || [];
        awwArray.forEach(row => {
          row.startDate = new Date(row.startDate);
          row.endDate = new Date(row.endDate);
        });
        let newState = {
          doi: new Date(hash.doi),
          startDate: new Date(hash.startDate),
          endDate: new Date(hash.endDate),

          inputAww: hash.inputAww,
          aww: hash.aww,

          isManualAww: hash.isManualAww,
          awwArray: awwArray
        };
        // console.log(newState);
        this.setState(newState, this.fetchTD);
      }
      catch (e) {
        this.props.showError(e, 'Invalid file format');
        console.error(e);
      }
    });
    reader.readAsBinaryString(file);
  }

  handleMenuMail = () => {
    let s = getTDForPrint(this.state);
    sendMail('', 'Temporary Total Disability', s);
  }

  handleMenuClear = () => {
    this.setState(this.initialState, this.fetchTD);
  }

  handleMenuCopy = () => {
    let s = getTDForPrint(this.state);
    this.props.copyToClipboard(s);
  }

  // --------------------- Rendering ---------------------
  render() {
    const { classes } = this.props;

    return (
      <React.Fragment>
      <input type="file" id="file" ref="fileUploader" style={{display: "none"}} onChange={this.onUploadFile}/>
      <MuiPickersUtilsProvider utils={ DateFnsUtils }>
      <Grid container spacing={1} className={classes.root} justifyContent="center">
        <Grid item xs={12} className={classes.alignCenter}>
          {/* Date of Injury */}
          <Paper className={classes.withSpacing}>
            {/* views={["year"]} */}
            <DatePicker
              label="Date of Injury"
              variant="outlined"
              format={'MM/dd/yyyy'}
              minDate={this.minDate}
              maxDate={this.maxDate}
              value={this.state.doi}
              onChange={this.onDateOfInjuryChange}
            />
          </Paper>
        </Grid>

        <Grid item xs={3}  className={classes.alignCenter}>
          {/* TTD Earnings */}
          <Paper className={classes.withSpacing}>
            <FormControl>
              <FormLabel component="legend">TTD Earnings</FormLabel>
              <div className={classes.alignLeft}>
                <TextField
                  id="minAWW"
                  label="Min"
                  value={currencyFormatter.format(this.state.minAWW)}
                  className={ classes.textField }
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  id="maxAWW"
                  label="Max"
                  value={currencyFormatter.format(this.state.maxAWW)}
                  className={ classes.textField }
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </div>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={3}  className={classes.alignCenter}>
          {/* TTD Payment / Rate */}
          <Paper className={classes.withSpacing}>
            <FormControl>
              <FormLabel component="legend">TTD Payment / Rate</FormLabel>
              <div className={classes.alignLeft}>
                <TextField
                  id="minRate"
                  label="Min"
                  value={currencyFormatter.format(this.state.minRate)}
                  className={ classes.textField }
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  id="maxRate"
                  label="Max"
                  value={currencyFormatter.format(this.state.maxRate)}
                  className={ classes.textField }
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </div>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={3} className={classes.alignCenter}>
          {/* SAWW Reporting */}
          <Paper className={classes.withSpacing}>
            <FormLabel component="legend">SAWW Reporting</FormLabel>
            <TextField
              id="saww"
              value={currencyFormatter.format(this.state.saww)}
              className={classes.textFieldLarge}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={3} className={classes.alignCenter}>
          {/* Percent Increase */}
          <Paper className={classes.withSpacing}>
            <FormLabel component="legend">Percent Increase</FormLabel>
            <TextField
              id="increase"
              value={this.state.increase}
              className={classes.textFieldLarge}
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={3}  className={classes.alignCenter}>
          {/* Input AWW */}
          <Paper className={classes.withSpacing}>
            <FormControl margin='none' >
              <React.Fragment>
                <List dense disablePadding>
                  <ListItem button dense key='inputAww' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        disabled={ this.state.isManualAww }
                        indeterminate={ this.state.isManualAww }
                        checked={ this.state.inputAww }
                        onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                        color="primary"
                        inputProps={{ 'aria-labelledby': 'AWW' }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={ this.state.isManualAww ? 'Manual AWW' : 'Input AWW' } />
                    <ListItemSecondaryAction>
                      <Tooltip title="Manually input work periods and wages" aria-label="Add">
                        <IconButton
                          edge="end"
                          color={ this.state.awwArray.length > 0 ? "primary" : "inherit" }
                          aria-label="edit"
                          onClick={ this.onDialogOpen }>
                          <EditIcon />
                        </IconButton>
                      </Tooltip>
                    </ListItemSecondaryAction>
                  </ListItem>
                </List>
                <TextField
                  id="aww"
                  value={ this.state.aww }
                  onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                  onChange={ (e) => this.setState({ aww: e.target.value, inputAww: true }) }
                  onFocus={ (e) => e.target.select() }
                  onBlur={ (e) => this.onAwwChanged(e.target.value) }
                  className={ classes.textFieldLarge }
                  margin="dense"
                  InputProps={{
                    readOnly: this.state.isManualAww
                  }}
                />
              </React.Fragment>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={3}  className={classes.alignCenter}>
          {/* PD Rate */}
          <Paper className={classes.withSpacing}>
            <FormControl>
              <React.Fragment>
                <List dense disablePadding>
                  <ListItem button dense key='inputPdRate' onClick={() => this.onInputAwwChanged(!this.state.inputAww)}>
                    <ListItemIcon>
                      <Checkbox
                        edge="start"
                        tabIndex={-1}
                        disableRipple
                        disabled={ this.state.isManualAww }
                        indeterminate={ this.state.isManualAww }
                        checked={ this.state.inputAww }
                        onChange={ (e) => this.onInputAwwChanged(e.target.checked) }
                        color="primary"
                        inputProps={{ 'aria-labelledby': 'PDRate' }}
                      />
                    </ListItemIcon>
                    <ListItemText primary={ this.state.pdRateText } />
                  </ListItem>
                </List>
                <TextField
                  id="pdRate"
                  value={ this.state.pdRate }
                  onKeyPress={ e => e.key == 'Enter' && e.target.blur() }
                  onChange={ (e) => this.setState({ pdRate: e.target.value, inputAww: true }) }
                  onFocus={ (e) => e.target.select() }
                  onBlur={ (e) => this.onPdRateChanged(e.target.value) }
                  className={ classes.textFieldLarge }
                  margin="dense"
                  InputProps={{
                    readOnly: this.state.isManualAww
                  }}
                />
              </React.Fragment>
            </FormControl>
          </Paper>
        </Grid>

        {/* Start Date */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.withSpacing}>
            <div className="picker">
              <DatePicker
                variant="outlined"
                label="Start Date"
                value={ this.state.startDate }
                onChange={ this.onStartDateChanged }
                format={ 'MM/dd/yyyy' }
              />
            </div>
          </Paper>
        </Grid>

        {/* End Date */}
        <Grid item xs={3} className={classes.alignCenter}>
          <Paper className={classes.withSpacing}>
            <div className="picker">
              <DatePicker
                variant="outlined"
                label="End Date"
                value={ this.state.endDate }
                onChange={ this.onEndDateChanged }
                format={ 'MM/dd/yyyy' }
              />
            </div>
          </Paper>
        </Grid>

        <Grid item xs={4}  className={classes.alignCenter}>
          {/* Weeks / Days */}
          <Paper className={classes.withSpacing}>
            <FormControl>
              <FormLabel component="legend">Weeks / Days</FormLabel>
              <div className={classes.alignLeft}>
                <TextField
                  id="weeks"
                  label=""
                  value={this.state.weeks}
                  className={ classes.textField }
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                />
                <TextField
                  id="days"
                  label=""
                  value={this.state.days}
                  className={ classes.textField }
                  margin="normal"
                  InputProps={{
                    readOnly: true,
                  }}
                />
              </div>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={4}  className={classes.alignCenter}>
          {/* Weeks / Days */}
          <Paper className={classes.withSpacing}>
            <FormControl>
              <FormLabel component="legend">Total Days</FormLabel>
              <TextField
                id="totalDays"
                label=""
                value={this.state.totalDays}
                className={ classes.textField }
                margin="normal"
                InputProps={{
                  readOnly: true,
                }}
              />
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={4} className={classes.alignCenter}>
          {/* Amount */}
          <Paper className={classes.withSpacing}>
            <FormLabel component="legend">Total TD Liability</FormLabel>
            {/*label="Amount"*/}
            <TextField
              id="amount"
              error={ this.state.warning != '' }
              variant="outlined"
              helperText={ this.state.warning }
              value={currencyFormatter.format(this.state.amount)}
              className={ classes.textFieldLarge }
              margin="normal"
              InputProps={{
                readOnly: true,
              }}
            />
          </Paper>
        </Grid>

        <Grid item xs={12} className={classes.alignCenter}>
          <Paper className={classes.withSpacing}>
            <div className={classes.pre}>
              <Typography variant="body1">
                {tdText}
              </Typography>
            </div>
          </Paper>
        </Grid>

      </Grid>

      <TempDisabilityEarningsDialog
        classes={{
          paper: classes.withSpacing,
        }}
        id="dialog"
        keepMounted
        isOpen={ this.state.isDialogOpen }
        onValueChange={ this.onDialogChange }
        onClose={ this.onDialogClose }
        dateOfInjury={ this.state.doi }
        value={ this.state.awwDialogArray }
      />

      </MuiPickersUtilsProvider>
      </React.Fragment>
    );
  }

};

export default withStyles(styles)(withErrorHandling(TempDisability));

const tdText = `Temporary disability payments are paid at 2/3 of the weekly earnings within the limits specified. LC 4653.

Aggregate disability payments for a single injury occurring on or after 4/19/04, causing temporary disability shall not extend for more than 104 compensable weeks within a period of two years from the date of commencement of temporary disability payment.
Aggregate disability payments for a single injury occurring on or after 1/1/2008 shall not extend for more than 104 compensable weeks within a period of five years from the date of injury.
Certain acute or severe disabilities extend for 240 weeks. LC 4656.

For injuries occurring on or after 1/1/2005 commencing 1/1/2007 the limits are increased annually by percentage increase of State Average Weekly Wage (SAWW). LC 4453(a)(10).`;

